import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

type FindInvitationsParams = {
  organizationId: string;
  filters: Record<string, unknown>;
};

type CreateInvitationsParams = {
  organizationId: string;
};

function getOrganizationsHelper() {
  return clientApi.getOCClient().helpers.employer.organizations;
}

function getInvitationsHelper(organizationId: string) {
  return getOrganizationsHelper().id(organizationId).invitations;
}

const {
  useFind: useOrganizationInvitations,
  useCreate: useOrganizationInvitationsCreation,
  useGet: useOrganizationInvitation,
  useDelete: useDeleteOrganizationInvitation,
} = getCRUDHooks({
  entityName: 'organizationInvitation',
  find: ({ organizationId, filters }: FindInvitationsParams) =>
    getInvitationsHelper(organizationId).find(filters),
  create: (newInvitation: any, { organizationId }: CreateInvitationsParams) =>
    getInvitationsHelper(organizationId).create(newInvitation),
  get({ id, queryParams }) {
    const request = clientApi.getOCClient().helpers.employer.invitations.get(id, false);

    request.setQueryParams(queryParams);
    return request.execute();
  },
  remove: ({
    targetId: organizationId,
    options,
  }: {
    targetId: string;
    options: string[] | Record<string, any>;
  }) => getOrganizationsHelper().deleteInvitations(organizationId, options),
});

type OrganizationId = string | number;

type CreateResendParams = {
  targetId: OrganizationId;
};

type ResendOptions = number[] | Record<string, any>;

const { useCreate: useResendOrganizationInvitation } = getCRUDHooks({
  entityName: 'resendOrganizationInvitation',
  create: (resendOptions: ResendOptions, { targetId: organizationId }: CreateResendParams) =>
    getOrganizationsHelper().resendInvitations(organizationId, resendOptions),
});

export {
  useOrganizationInvitations,
  useOrganizationInvitationsCreation,
  useOrganizationInvitation,
  useResendOrganizationInvitation,
  useDeleteOrganizationInvitation,
};
